var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHolidayIconDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31.4386,
    rx: 15.7193,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 9.05273C12.3197 9.05273 9.33301 12.0394 9.33301 15.7194C9.33301 19.3994 12.3197 22.3861 15.9997 22.3861C19.6797 22.3861 22.6663 19.3994 22.6663 15.7194C22.6663 12.0394 19.6797 9.05273 15.9997 9.05273ZM15.9997 21.0527C13.0597 21.0527 10.6663 18.6594 10.6663 15.7194C10.6663 12.7794 13.0597 10.3861 15.9997 10.3861C18.9397 10.3861 21.333 12.7794 21.333 15.7194C21.333 18.6594 18.9397 21.0527 15.9997 21.0527ZM15.9997 11.7194C13.7997 11.7194 11.9997 13.5194 11.9997 15.7194C11.9997 17.9194 13.7997 19.7194 15.9997 19.7194C18.1997 19.7194 19.9997 17.9194 19.9997 15.7194C19.9997 13.5194 18.2663 11.7194 15.9997 11.7194ZM17.9997 16.3861H13.9997V15.0527H17.9997V16.3861Z",
    fill: "#CBC8C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidayIconDisable);
export default __webpack_public_path__ + "static/media/holidayIconDisable.2dc3039140834b20e01e5ee1775fcab4.svg";
export { ForwardRef as ReactComponent };